import i18n from '~/i18n';
import { WalletOutlined } from '@ant-design/icons';
import useOpenPaymentPanel from '../PaymentPanel';
import useOpenPaymentDonePanel from '../PaymentDonePanel';
import { PaymentMethod } from '~/types/Payment';
import { useContext } from 'react';
import { OrderContext } from '~/App/Layout/providers/OrderProvider';
import { CartActionContext } from '~/App/Layout/providers/CartProvider';
import { useNavigate } from 'react-router-dom';
import PageContext from '../../context';
import { payOrder } from '../../../../api';
import message from '~/utils/message';
import { Order } from '@restaurant/api';

const usePayButton = ({ order }: { order: Order }) => {
  const { setPaid } = useContext(PageContext);
  const openPaymentPanel = useOpenPaymentPanel();
  const openPaymentDonePanel = useOpenPaymentDonePanel();
  const { order: currentOrder, newOrder } = useContext(OrderContext);
  const { resetCart } = useContext(CartActionContext);
  const navigate = useNavigate();

  return {
    key: 'pay',
    text: i18n.t('cart_pay'),
    icon: <WalletOutlined />,
    onClick: () => {
      if (
        !order.batches.every((items) =>
          items.every(({ isChecked }) => isChecked)
        )
      ) {
        message.error(
          'Order hanya bisa dibayar bila semua item sudah terceklis!'
        );
        return;
      }

      openPaymentPanel({
        totalPrice: order.totalPrice,
        onSubmit: async ({ roundingAmount, payments }) => {
          const totalPaymentAmount = payments.reduce((acc, { amount }) => {
            acc += amount;
            return acc;
          }, 0);

          const paymentProcessed = payments.map((p) => {
            if (p.method === PaymentMethod.Cash) {
              /**
               * Example:
               * Total Price 500.0000
               * Total Payment 600.000
               * Raw Cash 120.000
               * -------------
               * Change = Total Payment - Total Price = 600.000 - 500.000 = 100.000
               * Actual Cash Paid = Raw Cash - Change = 120.000 - 100.000 = 20.000
               */
              const change =
                totalPaymentAmount - (order.totalPrice - roundingAmount);
              const amount = p.amount - change;
              return {
                method: p.method,
                description: p.description,
                amount,
                change,
                cash: p.amount,
              };
            } else {
              return p;
            }
          });

          try {
            await payOrder(order.orderId, {
              roundingAmount,
              payments: paymentProcessed,
            });
            setPaid(true);
            openPaymentDonePanel({
              order,
              totalPrice: order.totalPrice,
              roundingAmount,
              payments,
              onSubmit: () => {
                if (
                  !currentOrder.isNew &&
                  currentOrder.orderId === order.orderId
                ) {
                  newOrder();
                  resetCart();
                }
                navigate('/');
              },
            });
          } catch (e: any) {
            message.error('Gagal bayar:' + e.message);
          }
        },
      });
    },
  };
};

export default usePayButton;
